import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/index.vue'

//登陆
import Login from '../views/login/login.vue'
import Register from '../views/login/register.vue'

//工作台
// import Worktop from '../views/baseData/worktop.vue'

// //项目
// import ProjectList from '../views/project/projectList.vue'

// //设备Admini
// import DeviceAdmin from '../views/device/deviceAdmin.vue'
// //设备传感器
// import SensorAdmin from '../views/sensor/sensorAdmin.vue'
// //套装管理
// import SuitAdmin from '../views/suit/suitAdmin.vue'

//项目案例
import Case from '../views/case/case.vue'
//产品服务proService
import ProService from '../views/product/proService.vue'

//新闻
import News from '../views/news/news.vue'
//banner
import Banner from '../views/banner/banner.vue'

//宽带
import broadband from '../views/broadband/broadband.vue'
//系统设置
import UserList from '../views/systemSetup/userList.vue'
import SysFunc from '../views/systemSetup/sysFunc.vue'
import SysRole from '../views/systemSetup/sysRole.vue'
import SysMenu from '../views/systemSetup/sysMenu.vue'

Vue.use(Router)

const routers=new Router({
  mode: 'history',
  routes: [
      {
      path: '/index',
      name: 'index',
      component: Index,
      children:[
        {
          path: '/userList',
          name: 'userList',
          component: UserList,
        },{
          path: '/sysFunc',
          name: 'sysFunc',
          component: SysFunc,
        },{
          path: '/sysRole',
          name: 'sysRole',
          component: SysRole,
        },{
          path: '/sysMenu',
          name: 'sysMenu',
          component: SysMenu,
        },{
          path: '/case',
          name: 'case',
          component: Case,
        },{
          path: '/proService',
          name: 'proService',
          component: ProService,
        },{
          path: '/news',
          name: 'news',
          component: News,
        },{
          path: '/banner',
          name: 'banner',
          component: Banner,
        },{
          path: '/broadband',
          name: 'broadband',
          component: broadband,
        }
      ]
    },{
      path: '/login',
      name: 'login',
      component: Login
    },{
      path: '/register',
      name: 'register',
      component: Register
    },
    { path: '/', redirect:'/login'},
    { path: '*', redirect:'/login'}
  ]
})
// routers.beforeEach((to,from,next)=>{
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   // safari
//   window.pageYOffset = 0
//   next()
// })
export default routers



// WEBPACK FOOTER //
// ./src/router/index.js